import { memo } from 'react';
import { UserInput } from 'src/actuators/user-input/types';
import { LocalesEnum, RegionsEnum } from 'src/generated/operations';
import { prepareUserInputFormValues } from 'src/actuators/common/prepareUserInputFormValues.ts';
import { I18n } from 'src/modules/common/components/I18n/I18n.tsx';
import { MapFieldToLabel } from 'src/actuators/common/UserInputFields.ts';
import { JoinReactNodes } from 'src/common/JoinReactNodes.tsx';

type Props = {
    region: RegionsEnum;
    state: UserInput;
    currentLocale: LocalesEnum;
    isLinear: boolean;
}

export const ActuatorBreadcrumbValue = memo(({
    region,
    state,
    isLinear,
    currentLocale,
}: Props) => {
    const rows = prepareUserInputFormValues({
        currentLocale,
        isLinear,
        currentRegion: region,
        userInput: state,
    }).filter(([_, value]) => Boolean(value)).map(([label, value, unit]) => {
        const lines = [];

        if (typeof label !== 'string' && [MapFieldToLabel.air, MapFieldToLabel.crankArmLength].includes(label.key)) {
            lines.push(<I18n messageId={label.key}/>);
        }

        lines.push(typeof value === 'string' ? value : <I18n messageId={value.key}/>);

        if (typeof unit !== 'string') {
            lines.push(<I18n messageId={unit.key}/>);
        }

        return (<JoinReactNodes separator=" " content={lines}/>);
    });
    return (<JoinReactNodes separator=", " content={rows}/>);
});
